const routes = [
  {
    path: '/',
    // redirect: 'index',
    component: () => import('@/views/home/Home.vue')
  },
  {
    path: 'index',
    name: 'index',
    component: () => import('@/views/home/Home.vue')
  },
  {
    path: 'home/news',
    redirect: 'home/news/list'
  },
  {
    path: 'home/news/list',
    name: 'home/news/list',
    component: () => import('@/views/home/news/List.vue'),
    meta: {
      cacheTo: ["home/news/info"], //只有从本路由进入这个数组里的路由才会缓存list这个页面
      keepAlive: true,
    }
  },
  {
    path: 'home/news/info',
    name: 'home/news/info',
    component: () => import('@/views/home/news/Info.vue')
  },
]

export default routes;
